/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfirmAdminLoginTicketRequest } from '../models/ConfirmAdminLoginTicketRequest';
import type { CreateAdminLoginTicketRequest } from '../models/CreateAdminLoginTicketRequest';
import type { SuccessResponse_AdminLoginExchangeResponse_ } from '../models/SuccessResponse_AdminLoginExchangeResponse_';
import type { SuccessResponse_AdminLoginTicketResponse_ } from '../models/SuccessResponse_AdminLoginTicketResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminAuthService {
    /**
     * Create Login Ticket Endpoint
     * POST /api/v1/admin-auth/login-tickets — 创建电脑端扫码登录票据.
     * @returns SuccessResponse_AdminLoginTicketResponse_ Successful Response
     * @throws ApiError
     */
    public static createLoginTicketEndpointApiV1AdminAuthLoginTicketsPost({
        requestBody,
    }: {
        requestBody: CreateAdminLoginTicketRequest,
    }): CancelablePromise<SuccessResponse_AdminLoginTicketResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin-auth/login-tickets',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Login Ticket Status Endpoint
     * GET /api/v1/admin-auth/login-tickets/{ticket} — 查询票据状态.
     * @returns SuccessResponse_AdminLoginTicketResponse_ Successful Response
     * @throws ApiError
     */
    public static loginTicketStatusEndpointApiV1AdminAuthLoginTicketsTicketGet({
        ticket,
    }: {
        ticket: string,
    }): CancelablePromise<SuccessResponse_AdminLoginTicketResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin-auth/login-tickets/{ticket}',
            path: {
                'ticket': ticket,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Login Ticket Wxacode Endpoint
     * GET /api/v1/admin-auth/login-tickets/{ticket}/wxacode — 小程序确认码图片.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static loginTicketWxacodeEndpointApiV1AdminAuthLoginTicketsTicketWxacodeGet({
        ticket,
    }: {
        ticket: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin-auth/login-tickets/{ticket}/wxacode',
            path: {
                'ticket': ticket,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Confirm Login Ticket Endpoint
     * POST /api/v1/admin-auth/login-tickets/{ticket}/confirm — 小程序扫码确认.
     * @returns SuccessResponse_AdminLoginTicketResponse_ Successful Response
     * @throws ApiError
     */
    public static confirmLoginTicketEndpointApiV1AdminAuthLoginTicketsTicketConfirmPost({
        ticket,
        requestBody,
    }: {
        ticket: string,
        requestBody: ConfirmAdminLoginTicketRequest,
    }): CancelablePromise<SuccessResponse_AdminLoginTicketResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin-auth/login-tickets/{ticket}/confirm',
            path: {
                'ticket': ticket,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Exchange Login Ticket Endpoint
     * POST /api/v1/admin-auth/login-tickets/{ticket}/exchange — 电脑端换取 JWT.
     * @returns SuccessResponse_AdminLoginExchangeResponse_ Successful Response
     * @throws ApiError
     */
    public static exchangeLoginTicketEndpointApiV1AdminAuthLoginTicketsTicketExchangePost({
        ticket,
    }: {
        ticket: string,
    }): CancelablePromise<SuccessResponse_AdminLoginExchangeResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin-auth/login-tickets/{ticket}/exchange',
            path: {
                'ticket': ticket,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
